// List types
export const PACK_LIST_RESET = 'PACK_LIST_RESET';
export const PACK_LIST_VIEW = 'PACK_LIST_VIEW';
export const PACK_LIST_SUCCESS = 'PACK_LIST_SUCCESS';


// Show types
export const PACK_RESET = 'PACK_RESET';
export const PACK_SUCCESS = 'PACK_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/pack/mutation-types.js